import { get } from '@ember/object';
import { isNone, isBlank } from '@ember/utils';

const lowerCase = (str: unknown) => {
  if (typeof str !== 'string' || isNone(str)) {
    return '';
  }

  return str.toLocaleLowerCase();
};

export default function <T extends Record<string, any>>(
  collection: T[] = [],
  properties: string[] = [],
  searchTerm = '',
) {
  if (isBlank(searchTerm)) {
    return collection;
  }

  return collection.filter((item) => {
    return properties.some((property) => {
      if (!(property in item)) {
        return false;
      }

      let value = get(item, property as keyof T);
      return !isBlank(value) && lowerCase(value).includes(lowerCase(searchTerm));
    });
  });
}
